import { render, staticRenderFns } from "./BarangayForm.vue?vue&type=template&id=2954df02"
import script from "./BarangayForm.vue?vue&type=script&lang=js"
export * from "./BarangayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports